export default "__VITE_ASSET__10839a68__"